import { useEffect, useState } from 'react'

const useDarkMode = (): boolean => {
  const [isDark, setIsDark] = useState(false)

  useEffect(() => {
    const html = document.documentElement
    const observer = new MutationObserver(() => {
      setIsDark(html.classList.contains('dark'))
    })

    setIsDark(html.classList.contains('dark'))

    observer.observe(html, { attributes: true, attributeFilter: ['class'] })

    return () => observer.disconnect()
  }, [])

  return isDark
}

export default useDarkMode
